import axios from 'axios';
import { AdresseIP } from './AdresseIp';

export class ChargementAdmissibleService {

    constructor(){
        this.adresse = new AdresseIP()
    }
    
    chargementFichier(donneeFichier){
        const url = this.adresse.getAdresseIP() +"/service/api/hebergement-cenou/campus-faso/upload"
        return axios.post(url, donneeFichier)
                    .then(res => res.data);
    }

    validationTypeStagiaire(libelleTypeStagiaire) {
        const url = this.adresse.getAdresseIP() +"/service/api/campusfaso-lmd/campus-faso/type-stagiaire"
        return axios.post(url,libelleTypeStagiaire).then(res => res.data );
    }

    getTypeStagiaire() {
        const url = this.adresse.getAdresseIP() +"/service/api/campusfaso-lmd/campus-faso/type-stagiaire"
        return axios.get(url)
                    .then(res => res.data);
    }

    

}